import { Button } from "@nextui-org/react";

import { Container, Table, Grid, Loading, Col, Row, Text, Tooltip } from "@nextui-org/react";
import React from "react";

import BranchDropDown from "./branchdropdown";
import ConfuseButton from "./confusebtn";

class MainPage extends React.Component {


    authBtnClick() {
        window.location.href = 'http://159.138.2.76:3000/login/oauth/authorize?client_id=58a33719-ed31-4454-9ce4-0e6f9ad838c2&redirect_uri=http://162.243.171.183/&response_type=code&state=1234';
    }

    access_token = ""
    auth(auto_code, complete) {

        fetch('http://162.243.171.183:8022/getaccesstoken', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Code: auto_code,
            })
        })
            .then(response => response.json())
            .then(data => {
                var respObj = JSON.parse(data);
                var err = respObj.error
                if (err != null || err != undefined) {
                    complete(err)
                    return
                }
                this.access_token = respObj.access_token;
                this.setState({ accessToken: respObj.access_token });
                complete(null)
            })
            .catch(error => {
                console.error(error);
                this.access_token = "access_token_fail"
                complete(error)
            });
    }

    columns = [
        {
            key: "project",
            label: "Project",
        },
        {
            key: "branch",
            label: "Branch",
        },
        {
            key: "action",
            label: "Action",
        }
    ];

    rows = [];
    loading = true;
    loadList() {
        if (this.access_token == null || this.access_token == undefined) {

            return
        }
        fetch('http://162.243.171.183:8022/user/repos', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: this.access_token,
            })
        })
            .then(response => response.json())
            .then(data => {
                this.rows = data
                this.loading = false
                this.setState({ isLoading: false });
            })
            .catch(error => {
                console.error(error);
                this.loading = false
                this.setState({ isLoading: false });
            });
    }

    code = null

    componentDidMount() {
        // 组件挂载后执行的操作
        const search = window.location.search; // 获取 URL 中的查询字符串，如 "?foo=bar"
        const params = new URLSearchParams(search); // 使用 URLSearchParams 解析查询字符串
        const code = params.get('code');
        if (code == null) {
            return
        }
        this.code = code
        this.auth(code, (authRes) => {
            if (authRes == null) {
                //auth success
                //load list
                this.loadList()
                return
            }
            //auth fail
            window.location.href = "http://162.243.171.183/"
        })
    }

    docodeconfuse = () => {

    }
    selectBranchForBranch
    constructor(props) {
        super(props);
        this.selectBranchForBranch = {}
    }

    branchDidChange = (fullName, toBranch) => {
        this.selectBranchForBranch[fullName] = toBranch
    }

    getBranch = (fullName) => {
        var branch = this.selectBranchForBranch[fullName]
        if (branch == null || branch == undefined) {
            this.rows.forEach(element => {
                if (element["full_name"] == fullName) {
                    branch = element["default_branch"];
                }
            });
        }
        return branch
    }


    renderCell = (projectItem, pKey) => {
        switch (pKey) {
            case "project":
                var value = projectItem["full_name"];
                return (
                    <Col>
                        <Row>
                            <Text b size={14} css={{ tt: "capitalize" }}>
                                {value}
                            </Text>
                        </Row>
                    </Col>
                );
                break;
            case "branch":
                var full_name = projectItem["full_name"];
                var db = projectItem["default_branch"];
                var branchItems = { token: this.access_token, full_name: full_name, default_branch: db }
                return (
                    <Col>
                        <Row>
                            <BranchDropDown items={branchItems} selectedDidChanged={this.branchDidChange}></BranchDropDown>
                        </Row>
                    </Col>
                );
                break;
            case "action":
                var full_name = projectItem["full_name"];
                return (<Row justify="center" align="center">
                    <Col css={{ d: "flex" }}>
                        <Tooltip content="混淆">
                            <ConfuseButton token={this.access_token} full_name={full_name} branchCallBack={this.getBranch}></ConfuseButton>
                        </Tooltip>
                    </Col>
                </Row>);
                break;
            default:
                break;
        }
    }

    render() {
        // this.loadList()
        const search = window.location.search; // 获取 URL 中的查询字符串，如 "?foo=bar"
        const params = new URLSearchParams(search); // 使用 URLSearchParams 解析查询字符串
        const code = params.get('code');
        if (code === null) {
            return (
                <Container>
                    <Grid>
                        <Button color="gradient" auto onPress={this.authBtnClick}>
                            授权登录
                        </Button>
                    </Grid>
                </Container>
            );
        }
        if (this.access_token === "") {
            //auth
            return <Container>
                <Loading>authing</Loading>;
            </Container>
        }
        if (this.loading) {
            return <Container>
                <Loading>Loading</Loading>;
            </Container>
        }
        return (
            <Container>
                <Table
                    aria-label="Example table with dynamic content"
                    css={{
                        height: "auto",
                        minWidth: "100%",
                    }}
                >
                    <Table.Header columns={this.columns}>
                        {(column) => (
                            <Table.Column key={column.key}>{column.label}</Table.Column>
                        )}
                    </Table.Header>
                    <Table.Body items={this.rows}>
                        {(item) => (
                            <Table.Row>
                                {(columnKey) => (
                                    <Table.Cell>{this.renderCell(item, columnKey)}</Table.Cell>
                                )}
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </Container>
        );
    }
}

export default MainPage;